/* global globalThis */
/**
 * Волна 37, участок «Казармы» (B1, B2): отряды ботов «золото+» не теряют рост в
 * фазе снабжения. Только у ботов золото+ (configs/botGoldPlus); каждая подчасть
 * — за своим гейтом A/B (isPreW37…Player в utils/bots/abTestGates).
 *
 * Откуда. Проба на 170 партиях ботов золото+ (main 19795091): с казармы на
 * квартал своего города уходят 2132 раза, из них в 83% без угрозы этого раунда
 * от еще не ходивших противников — 87% таких отрядов не на максимуме размера и
 * теряют рост. Главная причина — держатель гарнизона G волны 35 при угрозе
 * «скоро» (без учета очереди хода): 60–130 на квартале против 6–12 за стояние
 * на казарме. На казарме у лагеря (рост 4 вместо 2) отряды уходят так же часто,
 * как без лагеря (62% против 63%): бонус ×2 не отражает реальные +3 размера.
 *
 * Правило игры, на котором стоит участок: захват города проверяется в конце
 * раунда, а отряд на казарме город не держит. Без угрозы этого раунда (отряды
 * еще не ходивших противников или их найм не дотягиваются до кварталов) квартал
 * занимать незачем: в следующем раунде отряд с казармы встанет на смежный
 * квартал одним шагом — если смежных свободных кварталов хотя бы два и противник
 * «двойным ходом» (после бота в этом раунде, до него в следующем) не займет оба.
 */

// --- B1: резервный держатель на казарме

// Свободных (без отрядов) кварталов города, смежных казарме, у резервного
// держателя — не меньше. Проба (30 прод-реплеев, 934 этапа перемещения ботов
// золото+, этап доигран дважды — с волной 37 и legacy): при 2 уходов с казармы
// на квартал своего города без угрозы этого раунда 316 → 267, и 208 из
// оставшихся — казармы ровно с одним свободным смежным кварталом. Риск порога 1:
// противник, сходивший раньше бота, в следующем раунде займет этот квартал до
// его хода («двойной ход»). Факторный A/B харнесса (отчет 35, по 8160 партий):
// при 2 уходов без угрозы на квартал своего города −0.51 из 2.14 за партию, при
// 1 — −1.14; армия в конце +1.22 против +0.54, очки +2.14 [−0.40; 4.63] против
// +0.39, а потери городов не растут (−0.02 [−0.06; 0.02]; от «двойного хода» —
// 0.02 за партию в обоих плечах)
export const W37_RESERVE_MIN_FREE_QUARTERS = 1;

// 1 — отряд на казарме-резерве (или на казарме города, который уже держит свой
// отряд на квартале) без угрозы этого раунда не встает на кварталы этого города
// вовсе (фильтр клеток), кроме квартала, с которого по матожиданию убивает
// смежного врага (оборона в этом ходу). 0 — только мягкий резерв: ценность
// держателя G, волны 32 и обороны засчитывается и на казарме, а мелкие тяги к
// кварталу (градиент передовых кварталов +2, враг смежно кварталу +15, M4 вне
// удержания роста) остаются. Откуда: в пробе 299 уходов выше порога роста 60/80%
// — ровно градиент +2, его мягкий резерв не перебивает
export const W37_BARRACKS_STAY_HARD = 1;

// 1 — угрозой этого раунда в перемещении считается только фантомный найм
// живых противников (без isBot). На 200 прод-реплеях фантом живого сбывается в
// 36%, бота — в 4.5%. Пока 0: угроза — по брифу волны (любой фантом), а харнесс
// играет только ботами — при 1 фантомов там не было бы вовсе
export const W37_BARRACKS_HUMAN_RECRUITS_ONLY = 0;

// Бонус держателя квартала города, до которого в этом раунде дотягивается только
// фантомный найм ходящего после бота (уровня THIS_ROUND нет): доля ценности
// держателя волны 32 (calcCityHolderValue, 60–130). 1 — как у угрозы отрядами
// этого раунда: фантом живого сбывается в 36% против 50% у THIS_ROUND. Без
// бонуса заслон, нанятый наймом T на казарме, оставался бы на ней расти
export const W37_RECRUIT_HOLDER_FACTOR = 1;

// --- B2: стояние на казарме у лагеря

// Ценность одного размера роста, которую отряд теряет, уходя с казармы у
// лагеря: бонус стояния = (рост на казарме − рост вне ее) × это число. Шкала:
// штраф голода OUT_OF_SUPPLY_REACH_PENALTY 14 ≈ потеря 2 размеров, то есть ~7 за
// размер. 14 дает 42 обычному отряду у лагеря (+4 против +1): выше марша
// кампании (5 за клетку) и градиента целей (2 за клетку), ниже держания при
// угрозе этого раунда (60–130), убийства (40 + очки) и захвата (100+) — у
// зверолюдов и алмазной лиги (×4–5 к разнице роста) бонус стояния 56–70 и
// перебивает и убийство слабого врага. Факторный A/B харнесса (отчет 35, по 8160
// партий): при 8 поведение почти не менялось (уходов с казарм у лагеря без
// угрозы −1.04 п.п., рост у лагеря −0.21), очки −2.32 [−4.80; 0.31]; при 14 —
// −1.84 п.п., рост у лагеря +0.46 [0.14; 0.79], очки −0.75 [−3.13; 1.83]
export const W37_BARRACKS_GROWTH_PER_SIZE = 14;

// --- Калибровка харнесса: ручки через globalThis (в проде не заданы)

// Имена глобалов-переопределений ручек участка — для проверки SIM_W37_KNOBS в
// server/scripts/simulateBotBatch.js (имя вне списка — ошибка). Новая ручка — сюда же
export const W37_BARRACKS_KNOB_GLOBALS = [
  '__w37ReserveMinFreeQuarters',
  '__w37BarracksStayHard',
  '__w37BarracksHumanRecruitsOnly',
  '__w37RecruitHolderFactor',
  '__w37BarracksGrowthPerSize',
];

export const readW37BarracksKnob = (overrideName, value) => {
  const override = globalThis[overrideName];
  return typeof override === 'number' && Number.isFinite(override) ? override : value;
};

/**
 * Ручки участка на один шаг перемещения. Оверрайды харнесса —
 * globalThis.__w37ReserveMinFreeQuarters, __w37BarracksStayHard,
 * __w37BarracksHumanRecruitsOnly, __w37RecruitHolderFactor, __w37BarracksGrowthPerSize
 */
export const getW37BarracksKnobs = () => ({
  reserveMinFreeQuarters: readW37BarracksKnob('__w37ReserveMinFreeQuarters', W37_RESERVE_MIN_FREE_QUARTERS),
  isStayHard: readW37BarracksKnob('__w37BarracksStayHard', W37_BARRACKS_STAY_HARD) >= 1,
  isHumanRecruitsOnly: readW37BarracksKnob('__w37BarracksHumanRecruitsOnly', W37_BARRACKS_HUMAN_RECRUITS_ONLY) >= 1,
  recruitHolderFactor: readW37BarracksKnob('__w37RecruitHolderFactor', W37_RECRUIT_HOLDER_FACTOR),
  growthPerSize: readW37BarracksKnob('__w37BarracksGrowthPerSize', W37_BARRACKS_GROWTH_PER_SIZE),
});
